import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
// Models
import mInstallationLog from 'models/installationLog';
// Custom
import {
  installationLogDataShape, scenarioDataShape, deviceDataShape,
} from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';
import { CustomerItem, TimeItem } from 'components/items/InformationItems';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import ScenarioLogExec from './ScenarioLogExec';

const LogInfo = ({
  log, countryCode, scenarioAndDevice,
}) => {
  // Scenario log information
  const scenarioLog = log.scenario_log;
  const { scenario, device } = scenarioAndDevice;

  // Log information
  const customer = mInstallationLog.customer(log);
  const sourceIcon = mInstallationLog.sourceIcon(log);
  const sourceName = mInstallationLog.sourceName(log, scenario, countryCode);
  const triggerType = mInstallationLog.scenarioTriggerType(log);
  const result = mInstallationLog.result(log);

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-6">
          <InformationItem
            icon={sourceIcon}
            label={<LocalizedMessage id="field.source" />}
            value={<LocalizedMessage id={`installationLog.type.desc.${log.type}`} values={{ sourceName }} />}
          />
        </div>
        {customer && !_isEmpty(customer) && (
          <div className="col-12 col-md-6">
            <CustomerItem value={customer} />
          </div>
        )}
        <div className="col-12 col-md-6">
          <InformationItem
            icon={result.icon}
            iconColor={result.color}
            label={<LocalizedMessage id="field.resultScenario" />}
            value={<LocalizedMessage id={`installationLog.value.${log.value}`} />}
          />
        </div>
        {triggerType && triggerType.value !== 'na' && (
          <div className="col-12 col-md-6">
            <InformationItem
              icon={triggerType.icon}
              label={<LocalizedMessage id="field.accessType" />}
              value={<LocalizedMessage id={triggerType.labelId} />}
            />
          </div>
        )}
      </div>
      {scenarioLog && scenario && (
        <div className="pt-4">
          <CollapseBoxTemplate
            titleSize="sm"
            title={<LocalizedMessage id="info.scenarioExecution" values={{ scenarioName: <strong>{scenario.name}</strong> }} />}
          >
            <div className="px-2 pb-3">
              <div className="row">
                <div className="col-12 col-md-6">
                  <TimeItem value={<LocalizedStandardDate value={scenarioLog.date} />} />
                </div>
                <div className="col-12 col-md-6">
                  <InformationItem
                    icon={result.icon}
                    iconColor={result.color}
                    label={<LocalizedMessage id="field.executionStatus" />}
                    value={<LocalizedMessage id={`scenarioLog.status.${scenarioLog.status}`} />}
                  />
                </div>
              </div>
              <div className="row m-0 pt-2">
                <ScenarioLogExec
                  scenarioLog={scenarioLog}
                  device={device}
                />
              </div>
            </div>
          </CollapseBoxTemplate>
        </div>
      )}
    </div>
  );
};

LogInfo.propTypes = {
  log: installationLogDataShape.isRequired,
  countryCode: PropTypes.string.isRequired,
  scenarioAndDevice: PropTypes.shape({
    scenario: scenarioDataShape,
    device: deviceDataShape,
  }).isRequired,
};

const getScenarioAndDevice = (log, scenarios, devices) => {
  if (log && log.scenario_log) {
    const scenario = _find(scenarios, ['id', log.scenario_log.scenario_id]);
    const device = scenario && _find(devices, ['id', scenario.device_id]);
    return { scenario, device };
  }
  return {};
};

const mapStateToProps = (state, ownProps) => ({
  countryCode: state.intl.countryCode,
  scenarioAndDevice: getScenarioAndDevice(ownProps.log, state.installationScenario.list.elements, state.deviceData.elements),
});

module.exports = connect(
  mapStateToProps,
)(LogInfo);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/LogInfo.js